// extracted by mini-css-extract-plugin
export var chevron = "_j1-3";
export var chevronRotated = "_j1-4";
export var image = "_j1-1";
export var imageContainer = "_j1-0";
export var shippingAddress = "_j1-2";